<div class="row">
  <div class="col-sm">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Active {{ activeTotal }}</h5>
        <ma-doughnut-chart [data]="active"></ma-doughnut-chart>
      </div>
    </div>
  </div>
  <div class="col-sm">
    <ma-card title="Paused {{ pausedTotal }}">
      <ma-doughnut-chart [data]="paused"></ma-doughnut-chart>
    </ma-card>
  </div>
  <div class="col-sm">
    <ma-card title="Drafts {{ draftTotal }}">
      <ma-doughnut-chart [data]="draft"></ma-doughnut-chart
    ></ma-card>
  </div>
</div>

<div class="row">
  <div class="col-sm"></div>
</div>

<div class="row">
  <div class="col-sm">
    <ma-card>
      <div class="row no-gutters" [style.marginBottom.em]="1">
        <div class="input-group col-4">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
          <input
            placeholder="Include accountId"
            type="text"
            class="form-control form-control-sm filter-input"
            (input)="includeAccountId$.next($event.target.value)"
          />
        </div>
        <div class="input-group col-4 offset-1">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
          <input
            placeholder="Exclude accountId"
            type="text"
            class="form-control form-control-sm filter-input"
            (input)="excludeAccountId$.next($event.target.value)"
          />
        </div>
      </div>
      <table class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Account</th>
            <th scope="col">Active</th>
            <th scope="col">Paused</th>
            <th scope="col">Draft</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let account of filteredAccounts$ | async; index as index">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ account.accountId }}</td>
            <td>{{ account.active }}</td>
            <td>{{ account.paused }}</td>
            <td>{{ account.draft }}</td>
          </tr>
        </tbody>
      </table>
    </ma-card>
  </div>
</div>
